// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['colaborador_satya', 'diretoria', 'comercial']


const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Análise de Crédito',
    to: 'analiseCreditoList'
  }
]


export default [
  {
    path: '/analise-credito',
    name: 'analiseCreditoList',
    component: () => import('@/views/AnaliseCredito/AnaliseCreditoListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Análise de Crédito',
      breadcrumb: breadCrumb
    },
  },
  {
    path: '/analise-credito/novo',
    name: 'NovaAnaliseCredito',
    component: () => import('@/views/AnaliseCredito/AnaliseCreditoFormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Nova Análise de Crédito',
      breadcrumb: [
        ...breadCrumb,
        {
          label: 'Nova Análise de Crédito',
          to: 'NovaAnaliseCredito'
        }
      ]
    }
  },
  {
    path: '/analise-credito/:id/edit',
    name: 'AnaliseCreditoEdit',
    component: () => import('@/views/AnaliseCredito/AnaliseCreditoFormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Análise de Crédito',
      breadcrumb: [
        ...breadCrumb,
      {
          label: 'Análise de Crédito',
          to: 'AnaliseCreditoEdit'
        }
      ]
    }
  },
  {
    path: '/analise-credito/:id/view',
    name: 'AnaliseCreditoView',
    component: () => import('@/views/AnaliseCredito/AnaliseCreditoFormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Análise de Crédito',
      breadcrumb: [
        ...breadCrumb,
      {
          label: 'Análise de Crédito',
          to: 'NovaAnaliseCredito'
        }
      ]
    }
  },
];